import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './modules/rootReducer';
import rootSaga from './modules/rootSaga';

const configureStore = () => {
    const sagaMiddleware = createSagaMiddleware();

    // Use Redux DevTools (use browser extension)
    const keyDevTools = '__REDUX_DEVTOOLS_EXTENSION_COMPOSE__';
    const composeEnhancers = window[keyDevTools] || compose;

    const store = createStore(
        rootReducer,
        composeEnhancers(applyMiddleware(sagaMiddleware))
    );

    sagaMiddleware.run(rootSaga);

    return store;
};

export default configureStore;


// WEBPACK FOOTER //
// ./src/configureStore.ts